/**
 * Utility functions for consistent file naming across the application
 */

/**
 * Formats current date as YYYY-MMM-DD HH-mm-ss
 * @returns {string} Formatted date string
 */
export const formatDateForFilename = () => {
  const now = new Date();
  
  const year = now.getFullYear();
  const month = now.toLocaleString('default', { month: 'short' }); // Jan, Feb, etc.
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}-${minutes}-${seconds}`;
};

/**
 * Generates a standardised filename for Gliderol door designs
 * @returns {string} Formatted filename with .jpg extension
 */
export const generateGliderolFilename = () => {
  const dateString = formatDateForFilename();
  return `gliderol-door-design-${dateString}.jpg`;
};